export type PersonalAreaMenuItem = {
  title: string;
  path: string;
  exact?: boolean;
  hideInHeaderDropdown?: boolean;
};

export const personalAreaMenuItems: PersonalAreaMenuItem[] = [
  {
    title: 'Заказывай бесплатно',
    path: '/cabinet/share',
    exact: true,
    hideInHeaderDropdown: true
  },
  { title: 'Личный кабинет', path: '/cabinet', exact: true },
  { title: 'История заказов', path: '/cabinet/orders', exact: true },
  { title: 'Избранное', path: '/cabinet/products' },
  { title: 'Бонусы и задания', path: '/cabinet/bonuses' },
  { title: 'Уведомления', path: '/cabinet/notifications' },
  { title: 'Отзывы и вопросы', path: '/cabinet/reviews' },
  { title: 'Списки', path: '/cabinet/cart-templates' },
  { title: 'Рецепты', path: '/cabinet/recipes' },
  { title: 'Профиль', path: '/cabinet/profile' },
  { title: 'Настройки', path: '/cabinet/settings' }
];

export const personalAreaExitTitle = 'Выход';
export const personalAreaFeedbackTitle = 'Напишите нам';
